import AppConfig from "../../config";
import httpClient from "../../utils/http-client";
import JobPostingSearchInputModel from "../../models/company/jobPosting/request/JobPostingSearchInputModel";
import CompanyDashboardModel from "../../models/company/dashboard/response/CompanyDashboardModel";
import PagedListModel from "../../models/common/PagedListModel";
import AllProfilesSearchInputModel from "../../models/company/allProfiles/request/AllProfilesSearchInputModel";
import AllProfilesGridModel from "../../models/company/allProfiles/response/AllProfilesGridModel";
import BaseResponseList from "../../models/common/BaseResponseList";
import ZoomRecordingsModel from "../../models/company/allProfiles/response/ZoomRecordingsModel";
import BaseResponse from "../../models/common/BaseResponse";
import CompanyProfileRequest from "../../models/company/dashboard/request/CompanyProfileRequest";
import CompanyAdminDashboardModel from "../../models/company/addProfiles/response/CompanyAdminDashboardModel";
import FileDownloadModel from "../../models/common/FileDownloadModel";
import IdNameModel from "../../models/common/IdNameModel";
import RecruiterDashboardRequestModel from "../../models/company/dashboard/request/RecruiterDashboardRequestModel";
import RecruiterDashboardModel from "../../models/company/dashboard/response/RecruiterDashboardModel";
import RecruiterDashboardTodayInterviewModel from "../../models/company/dashboard/response/RecruiterDashboardTodayInterviewModel";
import CompanyLogoModel from "../../models/company/dashboard/response/CompanyLogoModel";

class CompanyDashboardService {
    async getJobPostingsDashboard(inputParms: JobPostingSearchInputModel) {
        let res: PagedListModel<CompanyDashboardModel> = await httpClient.post<PagedListModel<CompanyDashboardModel>>(AppConfig.company.dashboard.getJobPostingDashboard, inputParms);
        return res;
    };

    async getAllProfilesGrid(inputParms: AllProfilesSearchInputModel) {
        let res: PagedListModel<AllProfilesGridModel> = await httpClient.post<PagedListModel<AllProfilesGridModel>>(AppConfig.company.getAllProfiles, inputParms);
        return res;
    };

    async getAllProfilesExport(inputParms: AllProfilesSearchInputModel) {
        let res: any = await httpClient.post<any>(AppConfig.company.getAllProfilesExport, inputParms, { responseType: "blob" });
        return res;
    };

    async getZoomRecordings(zoomScheduleId: string) {
        let res: BaseResponseList<ZoomRecordingsModel[]> = await httpClient.get<BaseResponseList<ZoomRecordingsModel[]>>(AppConfig.company.getZoomRecordings + "/" + zoomScheduleId);
        return res;
    };

    async getCompanyProfile(companyId: string) {
        let res: BaseResponse<CompanyProfileRequest> = await httpClient.get<BaseResponse<CompanyProfileRequest>>(AppConfig.company.dashboard.getCompanyProfile + "/" + companyId);
        return res;
    };

    async saveCompanyProfile(companyProfile: CompanyProfileRequest) {
        let res: BaseResponse<boolean> = await httpClient.post<BaseResponse<boolean>>(AppConfig.company.dashboard.saveCompanyProfile, companyProfile);
        return res;
    };

    async getCompanyAdminDashboard(companyId: string) {
        let res: BaseResponse<CompanyAdminDashboardModel> = await httpClient.get<BaseResponse<CompanyAdminDashboardModel>>(AppConfig.company.dashboard.getCompanyAdminDashboard + "/" + companyId);
        return res;
    };

    async getRecruitersForCompany(companyId: string) {
        let res: BaseResponseList<IdNameModel[]> = await httpClient.get<BaseResponseList<IdNameModel[]>>(AppConfig.company.dashboard.getRecruitersForCompany  + "/" + companyId);
        return res;
    };

    async getRecruiterDashboard(request: RecruiterDashboardRequestModel) {
        let res: BaseResponse<RecruiterDashboardModel> = await httpClient.post<BaseResponse<RecruiterDashboardModel>>(AppConfig.company.dashboard.getRecruiterDashboard, request);
        return res;
    };

    async getTodayInterviews(request: RecruiterDashboardRequestModel) {
        let res: BaseResponseList<RecruiterDashboardTodayInterviewModel[]> = await httpClient.post<BaseResponseList<RecruiterDashboardTodayInterviewModel[]>>(AppConfig.company.dashboard.getTodayInterviews, request);
        return res;
    };

    async getCompanyLogo() {
        let res: BaseResponse<CompanyLogoModel> = await httpClient.get<BaseResponse<CompanyLogoModel>>(AppConfig.company.dashboard.getCompanyLogo);
        return res;
    };
}
const companyDashboardService = new CompanyDashboardService();
export default companyDashboardService;